import React, { useState } from "react";
import "../Styles/BusCard.css";
import wbtc from "../Images/wbtc.png"
import SelectSeatsScreen from "./SelectSeatsScreen";

function BusCard() {
  const[showSeat,setShowSeat] = useState(false)
  return (
    <section className="buslist-container-uniq">
      <h2 className="buslist-title-uniq">Delhi to Kanpur Buses</h2>
      <p className="buslist-subtext-uniq">199 buses found</p>

      {/* Operator Card */}
      <div className="operator-card-uniq">
        <div className="operator-left-uniq">
          <img
            src={wbtc}
            alt="WBTC Logo"
          />
          <div style={{display:"flex",flexDirection:"column",alignItems:"flex-start",fontWeight:"600"}}>
            <span>WBTC (West Bengal)</span>
            <p>76 Buses</p>
          </div>
        </div>
        <div className="operator-right-uniq">
          <span className="price-uniq">₹671-824/-</span>
          <a href="#" className="view-link-uniq">View buses</a>
        </div>
      </div>

      {/* Bus Card */}
      <div className="bus-card-uniq">
        <div className="bus-info-uniq">
          <h3>Intercity Smart Bus</h3>
          <p>Bharat Benz A/C seater / Sleeper</p>

          <div className="rating-uniq">
            <span className="star-uniq">⭐</span>
            <span className="rate-uniq">4.3</span>
            <span className="reviews-uniq">(154 reviews)</span>
          </div>
        </div>

        <div className="bus-timing-uniq">
          <div>
            <strong>21:00</strong>
            <p>02 Sep</p>
          </div>
          <div className="duration-uniq">09 hr 5 min</div>
          <div>
            <strong>06:05</strong>
            <p>03 Sep</p>
          </div>
        </div>

        <div className="bus-price-uniq">
          <h2>₹824/-</h2>
          <p className="seats-left-uniq">55 seats left</p>
          <button className="select-btn-uniq" onClick={()=>setShowSeat(!showSeat)}>{showSeat? "Hide Seats":"Select Seats"}</button>
        </div>
     
      </div>
        {showSeat? <SelectSeatsScreen/>: ""} 

    </section>
  );
}

export default BusCard;
